export default __webpack_public_path__ + "static/media/vikings.b72117ff.jpg";